import * as Sentry from '@sentry/nextjs';

import { DeviceCheckResult } from '~/generated/graphql';
import calculateScreenSize from '~/helpers/deviceChecks/calculateScreenSize';
import fetchFromElectron from '~/helpers/deviceChecks/fetchFromElectron';
import fetchFromExtension from '~/helpers/deviceChecks/fetchFromExtension';
import { DeviceCheckMetadata } from '~/types';

const checkMinScreenSize: DeviceCheckMetadata['check'] = async ({
  expectedValue,
  registrationDetails,
}) => {
  try {
    if (!expectedValue) {
      throw new Error('Expected value not provided');
    }

    const result = window.electron
      ? await fetchFromElectron('DISPLAY_INFO')
      : await fetchFromExtension('DISPLAY_INFO');
    const displayInfo = result.data?.[0];
    if (!displayInfo) {
      return {
        expectedValue,
        result: DeviceCheckResult.Fail,
      };
    }

    const screenSize = calculateScreenSize(displayInfo);
    const expectedScreenSize = parseFloat(expectedValue);
    const reportedScreenSize = screenSize.toString();

    if (!Number.isNaN(expectedScreenSize) && screenSize >= expectedScreenSize) {
      return {
        expectedValue,
        result: DeviceCheckResult.Pass,
        value: reportedScreenSize,
      };
    }
    return {
      expectedValue,
      result: DeviceCheckResult.Fail,
      value: reportedScreenSize,
    };
  } catch (err) {
    const e = err as Error;
    const error = new Error(
      JSON.stringify({
        error: e.message,
        registrationDetails,
      }),
    );

    Sentry.captureException(error);
    return {
      expectedValue,
      result: DeviceCheckResult.Fail,
      value: e.message,
    };
  }
};

export default checkMinScreenSize;
